"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SchoolActionEnum = void 0;
var SchoolActionEnum;
(function (SchoolActionEnum) {
  /** Могу изменить общие сведения */
  SchoolActionEnum["edit_profile"] = "edit_profile";
  /** Могу публиковать и взаимодействоть с модератором */
  SchoolActionEnum["publish"] = "publish";
  /** Могу присоединиться (как наблюдатель) */
  SchoolActionEnum["join_school"] = "join";
  /** Могу покинуть (как наблюдатель) */
  SchoolActionEnum["leave_school"] = "leave";
  /** Могу управлять банковскими картами */
  SchoolActionEnum["manage_bank_cards"] = "manage_bank_cards";
  /** Могу управлять расчётными параметрами преподавателей */
  SchoolActionEnum["manage_teacher_profits"] = "manage_teacher_profits";
  /** Могу назначать преподавателей */
  SchoolActionEnum["assign_teacher"] = "assign_teacher";
  /** Могу назначать владельцев */
  SchoolActionEnum["assign_owner"] = "assign_owner";
  /** Могу назначать управляющих */
  SchoolActionEnum["assign_manager"] = "assign_manager";
  /** Могу назначать модераторов */
  SchoolActionEnum["assign_moderator"] = "assign_moderator";
  /** Могу смотреть историю расчётов */
  SchoolActionEnum["use_billing_history"] = "use_billing_history";
  /** Могу управлять услугами школы */
  SchoolActionEnum["manage_user_services"] = "manage_user_services";
  /** Могу управлять расписанием школы */
  SchoolActionEnum["manage_schedule"] = "manage_schedule";
  /** Могу управлять контентом в школе */
  SchoolActionEnum["manage_content"] = "manage_content";
})(SchoolActionEnum = exports.SchoolActionEnum || (exports.SchoolActionEnum = {}));
